'use client';

import { useQuery } from '@tanstack/react-query';

import type { ProductHit } from '@libs/algolia';

import { fetchRecommendedProducts } from '../api';

export type QueryRecommendedProductsOptions = {
    productId: string;
    customerId: string;
    storeId?: string;
};

const DEFAULT_RECOMMENDED_PRODUCTS: ProductHit[] = [];

export const useQueryRecommendedProducts = ({ productId, storeId, customerId }: QueryRecommendedProductsOptions) => {
    const queryKey = ['fbt', productId, storeId, customerId];

    return useQuery({
        queryKey,
        queryFn: () => {
            if (!storeId) {
                return DEFAULT_RECOMMENDED_PRODUCTS;
            }
            return fetchRecommendedProducts({ productIds: [productId], storeId, customerId });
        },
        // staleTime – keep cache 1 hour - data is considered fresh for 1 hour,
        // and during this period, reusing the cache will not fetch new data.
        staleTime: 60 * 60 * 1000,
    });
};
